import { render } from "./AdminDisputes.vue?vue&type=template&id=4da66ddb&scoped=true"
import script from "./AdminDisputes.vue?vue&type=script&lang=js"
export * from "./AdminDisputes.vue?vue&type=script&lang=js"

import "./AdminDisputes.vue?vue&type=style&index=0&id=4da66ddb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da66ddb"]])

export default __exports__